import React, { useMemo } from "react"
import QRCode from "qrcode-generator"

/** Modules of empty space around the code. The spec wants 4, but this is a preview
 *  placeholder sitting on its own white plate, so keep it tight. */
const QUIET_ZONE = 1

type Props = {
  size?: string | number
  /** Encoded in the placeholder, so scanning a preview shows where it came from. */
  text?: string
}

const QRCodePlaceholder = ({ size = "100%", text = "Diobox" }: Props) => {
  const { path, extent } = useMemo(() => {
    const qr = QRCode(0, "M")
    qr.addData(text)
    qr.make()

    const count = qr.getModuleCount()
    const segments: string[] = []

    for (let row = 0; row < count; row += 1) {
      for (let col = 0; col < count; col += 1) {
        if (qr.isDark(row, col)) {
          segments.push(`M${col + QUIET_ZONE},${row + QUIET_ZONE}h1v1h-1z`)
        }
      }
    }

    return { path: segments.join(""), extent: count + QUIET_ZONE * 2 }
  }, [text])

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${extent} ${extent}`}
      shapeRendering="crispEdges"
    >
      <rect width={extent} height={extent} fill="#ffffff" />
      <path d={path} fill="#000000" />
    </svg>
  )
}

export default QRCodePlaceholder
